import { reducerWithInitialState } from 'typescript-fsa-reducers/dist'

/* Import our module's actions */
import * as a from './actions'
import * as dt from 'modules/database/types'
import produce from 'immer'
import { downloadedProduct, downloadedProject, updateProduct } from 'modules/database/actions'

export type StoreState = DeepReadonly<MutableStoreState>

interface MutableStoreState {
	currentProject?: dt.ProjectWithProducts
}

/**
 * The initial store state for this module.
 */
const INITIAL_STATE: StoreState = {
	
}

/**
 * Reducer function for this module.
 */
export const reducer = reducerWithInitialState(INITIAL_STATE)

reducer.case(a.updateEditingProject, (state, payload) => produce(state, draft => {
	draft.currentProject = payload
}))

reducer.case(a.newProject, (state) => produce(state, draft => {
	draft.currentProject = undefined
}))

reducer.case(updateProduct, (state, payload) => produce(state, draft => {
	if (payload.projectId === draft.currentProject?.projectId) {
		const productId = payload.product.productId

		if (draft.currentProject.products[productId]) {
			draft.currentProject.products[productId] = payload.product
		}
	}
}))

/* Apply synced changes to the current project directly from the downloaded data, rather than refetching
   the whole project. The products are preserved; they are synced individually by downloadedProduct.
 */
reducer.case(downloadedProject, (state, payload) => produce(state, draft => {
	if (payload.projectId === draft.currentProject?.projectId) {
		draft.currentProject = {
			...payload.project,
			products: draft.currentProject.products,
		}
	}
}))

reducer.case(downloadedProduct, (state, payload) => produce(state, draft => {
	if (payload.projectId === draft.currentProject?.projectId) {
		draft.currentProject.products[payload.product.productId] = payload.product
	}
}))
